<template>
  <div class="TemuOpportunityProduct">
    <div class="header-box">
      <div class="header-line">
        <span class="header-label">产品ID</span>
        <el-input placeholder="请输入产品ID" size="small" clearable v-model="params.goodsId"> </el-input>
        <span class="header-label">是否打星</span>
        <el-select placeholder="匹配类型" size="small" v-model="params.markStar">
          <el-option label="全部" value=""></el-option>
          <el-option label="已打星" value="true"></el-option>
          <el-option label="未打星" value="false"></el-option>
        </el-select>
        <el-button type="primary" size="small" @click="onQueryBtnClick">查询</el-button>
        <el-button type="primary" size="small" @click="onAddClick">新增</el-button>
      </div>
    </div>
    <el-table :data="tableData" border size="mini" :height="screenHeight" cell-class-name="out-table-cell" row-class-name="out-table-row" header-cell-class-name="out-table-header-cell" header-row-class-name="out-table-header-row">
      <el-table-column label="序号" width="45px" align="center">
        <template slot-scope="scope">
          {{ beginIndex + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column label="是否关注" width="100px">
        <template v-slot="scope">
          <el-checkbox v-model="scope.row.markStar" @change="markStarChange" :data-goods-id="scope.row.goodsId">{{ scope.row.markStar == 1 ? "已打星" : "" }}</el-checkbox>
        </template>
      </el-table-column>
      <el-table-column label="商品图片" width="100px">
        <template v-slot="scope">
          <el-image v-if="scope.row.sysImgUrls.length > 0" style="width: 80px; height: 80px" :src="scope.row.sysImgUrls[0]" @click="show(scope.row.sysImgUrls)"></el-image>
          <el-image v-else style="width: 80px; height: 80px"></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="goodsId" label="产品Id" width="120px"> </el-table-column>
      <el-table-column prop="name" label="产品名称" width="500px"> </el-table-column>
      <el-table-column label="开始时间" width="140px">
        <template v-slot="scope">
          <div>{{ new Date(scope.row.startTime).format("yyyy-MM-dd hh:mm:ss") }}</div>
          <div>{{ new Date(scope.row.endTime).format("yyyy-MM-dd hh:mm:ss") }}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column label="创建时间" width="140px">
        <template v-slot="scope">
          <div>{{ new Date(scope.row.createdAt).format("yyyy-MM-dd hh:mm:ss") }}</div>
        </template>
      </el-table-column> -->
      <el-table-column label="计划上架日期" width="100px">
        <template v-slot="scope">{{ scope.row.onlineDate ? scope.row.onlineDate : "" }} </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" width="80px"> </el-table-column>
      <el-table-column label="操作" width="180px">
        <template v-slot="scope">
          <el-button type="text" v-on:click="onEditClick(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination ref="pageNav" layout="prev,pager, next" background prev-text="上一页" next-text="下一页" :page-size="params.pageSize" :total="total" @prev-click="prevBtnClick" @next-click="nextBtnClick" @current-change="curBtnClick"> </el-pagination>

    <el-dialog title="更新机会商品" :visible.sync="dialogFormVisible" width="1000px">
      <div class="form-line">
        <span class="form-label">机会商品JSON</span>
        <el-input class="form-input" placeholder="请输入" v-model="addParams.productJson" type="textarea" size="small" :rows="10" style="width: 800px" clearable> </el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAddMaterialConfirm">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="编辑商品" :visible.sync="editDialogVisible" width="500px">
      <div class="form-line">
        <span class="form-label">计划上架日期</span>
        <el-date-picker v-model="editParams.onlineDate" type="date" placeholder="选择日期" style="width: 300px"> </el-date-picker>
      </div>
      <div class="form-line">
        <span class="form-label">备注</span>
        <el-input class="form-input" placeholder="请输入" v-model="editParams.remark" type="textarea" size="small" :rows="3" style="width: 300px" clearable> </el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleEditConfirm">确 定</el-button>
      </div>
    </el-dialog>

    <viewer :images="images">
      <img v-for="src in images" :key="src" :src="src" />
    </viewer>
  </div>
</template>

<script>
import { requestModules } from "@r";
import { colors } from "../../utils/constant.js";
export default {
  data() {
    return {
      colors: colors,
      screenHeight: document.body.clientHeight - 82 - 132,
      dialogFormVisible: false,
      editDialogVisible: false,
      beginIndex: 0,
      pageSize: 100,
      totalPage: 1,
      total: 1,
      currentPage: 1,
      tableData: [],
      addParams: {
        productJson: "",
      },
      params: { pageSize: 50, beginIndex: 0, markStar: "", goodsId: "" },
      editParams: { onlineDate: "", remark: "" },
      images: [],
    };
  },
  mounted() {
    this.fetchTemuOpportunityProducts();

    this.$eventBus.$on("resize", this.calculateHeight);
    this.calculateHeight();
  },
  beforeDestroy() {
    this.$eventBus.$off("resize", this.calculateHeight);
  },
  methods: {
    calculateHeight() {
      this.screenHeight = document.body.clientHeight - 82 - 132;
    },
    onAddClick() {
      this.addParams = {
        productJson: "",
      };
      this.dialogFormVisible = true;
    },
    onEditClick(row) {
      this.editParams = { onlineDate: row.onlineDate, remark: row.remark, goodsId: row.goodsId };
      this.editDialogVisible = true;
    },
    handleEditConfirm() {
      let params = { ...this.editParams };
      params.onlineDate && (params.onlineDate = params.onlineDate.format("yyyy-MM-dd"));

      requestModules
        .editOpportunityProduct(params)
        .then(res => {
          this.fetchTemuOpportunityProducts();
          this.editDialogVisible = false;
        })
        .catch(err => {
          this.$message({
            type: "error",
            message: err.message ? err.message : "未知错误",
          });
        });
    },
    handleAddMaterialConfirm() {
      let goods = [];
      let data = JSON.parse(this.addParams.productJson);
      data.result.list.forEach(item => {
        goods.push(item.biddingInvitationOrder);
      });

      console.log(goods);

      requestModules
        .updateTemuOpportunityProducts({ products: JSON.stringify(goods) })
        .then(res => {
          this.fetchTemuOpportunityProducts();
          this.dialogFormVisible = false;
        })
        .catch(err => {
          this.$message({
            type: "error",
            message: err.message ? err.message : "未知错误",
          });
        });
    },
    onQueryBtnClick() {
      this.fetchTemuOpportunityProducts();
    },
    fetchTemuOpportunityProducts() {
      requestModules
        .fetchTemuOpportunityProducts(this.params)
        .then(res => {
          if (res.result !== 1) {
            this.$message({
              type: "error",
              message: res.message ? res.message : "获取列表失败",
            });
            return;
          }

          this.tableData = res.ldata;

          this.total = res.total;
        })
        .catch(err => {
          this.$message({
            type: "error",
            message: err.message ? err.message : "未知错误",
          });
        });
    },
    prevBtnClick() {
      this.handlerPageChange();
    },
    nextBtnClick() {
      this.handlerPageChange();
    },
    curBtnClick() {
      this.handlerPageChange();
    },
    handlerPageChange() {
      let pageNav = this.$refs.pageNav;
      // let lastEmittedPage = pageNav.lastEmittedPage;
      let internalCurrentPage = pageNav.internalCurrentPage;
      this.params.beginIndex = (internalCurrentPage - 1) * this.params.pageSize;
      this.fetchTemuOpportunityProducts();
    },
    getColorLabel(colorType) {
      let color = this.colors.find(color => color.key == colorType);
      return color ? color.name : "";
    },
    show(images) {
      this.$viewerApi({
        images,
      });
    },
    markStarChange(vaue, event) {
      let goodsId = event.srcElement.parentNode.parentNode.getAttribute("data-goods-id");
      requestModules
        .opportunityProductMarkStar({ markStar: vaue, goodsId })
        .then(res => {
          this.fetchTemuOpportunityProducts();
          this.dialogFormVisible = false;
        })
        .catch(err => {
          this.$message({
            type: "error",
            message: err.message ? err.message : "未知错误",
          });
        });
    },
  },
};
</script>

<style lang="scss">
.TemuOpportunityProduct {
  padding-left: 10px;
  padding-bottom: 10px;
  background-color: white;

  .form-line {
    .form-label {
      margin: 5px 20px 5px 0px;
      width: 100px;
      font-weight: bold;
      text-align: right;
      display: inline-block;
      span {
        color: red;
      }
    }
    .form-input {
      width: 220px;
      margin: 5px 0px;
      vertical-align: middle;
    }
    .form-date {
      margin: 5px 0px;
    }
    .form-select {
      width: 220px;
      margin: 5px 0px;
      vertical-align: middle;
    }
    .form-group {
      width: 750px;
      margin: 5px 0px;
      display: inline-block;
      vertical-align: top;

      .el-checkbox {
        width: 70px;
      }
    }
  }
}
</style>
